import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inline-loader',
  templateUrl: './inline-loader.component.html',
  styleUrls: ['./inline-loader.component.css']
}) 
export class InlineLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
